import { useMutation } from '@tanstack/react-query';
import { startRenewalCheckout } from '@/api/renewal-offer.api';
import { RENEWAL_STRINGS } from '@/lib/constants/renewal-strings';
import { toast } from '@/lib/toast';
import { getApiErrorMessage } from '@/lib/utils/error.utils';

/**
 * Subscribe to a renewal plan (MYN-247, FR-297): the browser leaves for
 * Stripe, so success needs no message. A refusal (the offer just closed, a
 * payment already in progress) shows as a toast with the API's reason: the
 * panel has no surface of its own to hold it.
 *
 * @param startupId - the purchasing startup
 */
export function useStartRenewal(startupId: string | null) {
  return useMutation({
    mutationFn: (planId: string) => startRenewalCheckout(startupId as string, planId),
    onSuccess: ({ checkoutUrl }) => window.location.assign(checkoutUrl),
    onError: (error) => toast.error(getApiErrorMessage(error, RENEWAL_STRINGS.SUBSCRIBE_FAILED)),
  });
}
